import {StoreType} from '../../../types/sharedTypes';

export const resourcesSelector = (state: StoreType) => {
  return state.resourcesReducer.resources;
};
